import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('poApprovalList', [booksMenu])
  .controller('purchaseOrderApprovalController', purchaseOrderApprovalController)
  .name;
  
/* @ngInject */ function purchaseOrderApprovalController($scope, BooksSvc, BusyScreen, Session) {
  /*---------------------*/
  /* Sets default values */
  /*---------------------*/
  $scope.req = { reportFormat: 'PDF' };
  $scope.reportPage = Session.getSessionURL('/POApprovalList.aspx');

  /*----------------------------*/
  /* Validates the date formats */
  /*----------------------------*/
  $scope.valOption = {};
  $scope.validateInput = function () {
    return $scope.valOption.validate();
  };

  /*-------------------*/
  /* Load initial data */
  /*-------------------*/
  BooksSvc.getOrganization().then(function (resp) {
    $scope.org = resp.data;

    BooksSvc.viewChartOfAccounts().then(function (resp) {
      $scope.accounts = [
        { accountNumber: 'All', accountName: 'All Accounts', accountID: 0 }
      ].concat(resp.data);

      /*--------------------------------------------*/
      /* Sets the acctID here so that the All       */
      /* Accounts will be the default on page load. */
      /*--------------------------------------------*/
      $scope.req.acctID = 0;
    });
    BusyScreen.setBusy(false);
  });
}